"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _configuratorCarousel = _interopRequireDefault(require("../styles/configurator-carousel.css"));

var _configuratorCarousel2 = require("./configurator-carousel.props/configurator-carousel.propTypes");

var _configuratorCarouselControls = _interopRequireDefault(require("./configurator-carousel-controls"));

var _configuratorCarouselImages = _interopRequireDefault(require("./configurator-carousel-images"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _DataUtils = new _mmcDataUtilities["default"](),
    handleNestedProp = _DataUtils.handleNestedProp,
    isEmptyArray = _DataUtils.isEmptyArray,
    appendImageTransforms = _DataUtils.appendImageTransforms;

var getFirstImageInItems = function getFirstImageInItems(data) {
  return (0, _get["default"])(data, 'items[0].image.image');
};

var ConfiguratorCarousel = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(ConfiguratorCarousel, _React$PureComponent);

  ConfiguratorCarousel.resourceType = function resourceType() {
    return 'Carousel_1_0_0';
  };

  ConfiguratorCarousel.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var firstImage = getFirstImageInItems(props.data);
    var carouselImages = handleNestedProp(props, 'props.data.items');
    var carouselImagesLength = (0, _isEmpty["default"])(carouselImages) ? 0 : carouselImages.length;
    var newState = null;

    if (carouselImagesLength !== state.carouselImagesLength) {
      newState = {
        carouselImagesLength: carouselImagesLength
      };
    } // Reset slide index to `0` as new items have been passed


    if (firstImage && firstImage !== state.firstImage) {
      newState = _objectSpread(_objectSpread({}, newState), {}, {
        visibleImageIndex: 0,
        firstImage: firstImage
      });
    }

    return newState;
  };

  function ConfiguratorCarousel(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    var carouselImages = handleNestedProp(props, 'props.data.items');
    var carouselImagesLength = typeof carouselImages === 'string' ? 0 : carouselImages.length;
    var handleReloading = props.isLoading !== undefined;
    _this.state = {
      visibleImageIndex: 0,
      firstImage: getFirstImageInItems(props.data),
      carouselImagesLength: carouselImagesLength,
      firstImageIsLoading: false,
      sliding: false,
      direction: carouselImagesLength === 2 ? 'prev' : 'next',
      swipeThreshold: {
        x: 100,
        y: 100
      },
      origin: {
        x: 0,
        y: 0
      },
      previous: {
        x: 0,
        y: 0
      },
      cancelTouch: false,
      twoSlidesCarousel: 2,
      handleReloading: handleReloading
    };
    _this.handlePrevSlide = _this.handlePrevSlide.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleNextSlide = _this.handleNextSlide.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getOrder = _this.getOrder.bind((0, _assertThisInitialized2["default"])(_this));
    _this.doSliding = _this.doSliding.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTouchStart = _this.handleTouchStart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTouchMove = _this.handleTouchMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTouchEnd = _this.handleTouchEnd.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = ConfiguratorCarousel.prototype;

  _proto.handleNextSlide = function handleNextSlide() {
    var _this$state = this.state,
        visibleImageIndex = _this$state.visibleImageIndex,
        carouselImagesLength = _this$state.carouselImagesLength,
        twoSlidesCarousel = _this$state.twoSlidesCarousel;

    if (carouselImagesLength === twoSlidesCarousel && visibleImageIndex === 1) {
      return;
    }

    this.doSliding('next', visibleImageIndex === carouselImagesLength - 1 ? 0 : visibleImageIndex + 1);
  };

  _proto.handlePrevSlide = function handlePrevSlide() {
    var _this$state2 = this.state,
        visibleImageIndex = _this$state2.visibleImageIndex,
        carouselImagesLength = _this$state2.carouselImagesLength,
        twoSlidesCarousel = _this$state2.twoSlidesCarousel;

    if (carouselImagesLength === twoSlidesCarousel && visibleImageIndex === 0) {
      return;
    }

    this.doSliding('prev', visibleImageIndex === 0 ? carouselImagesLength - 1 : visibleImageIndex - 1);
  };

  _proto.handleTouchStart = function handleTouchStart(e) {
    if (e.touches.length === 1) {
      this.setState({
        origin: {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        },
        previous: {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        }
      });
    }
  };

  _proto.handleTouchMove = function handleTouchMove(e) {
    var _this$state3 = this.state,
        origin = _this$state3.origin,
        cancelTouch = _this$state3.cancelTouch,
        swipeThreshold = _this$state3.swipeThreshold;

    if (e.touches.length === 1 && cancelTouch !== true) {
      var swipeDistance = {
        x: origin.x - e.changedTouches[0].pageX,
        y: origin.y - e.changedTouches[0].pageY
      };
      this.setState({
        previous: {
          x: e.changedTouches[0].pageX,
          y: e.changedTouches[0].pageY
        }
      }); // if a true swipe has occured

      if (Math.abs(swipeDistance.x) > swipeThreshold.x) {
        var direction = 'next'; // is it a forward or previous swipe
        // TODO: if direction is RTL this will be the opposite ie:
        // TODO: swipeDistance.x < 0 ? (direction = "next") : (direction = "prev");

        direction = swipeDistance.x > 0 ? 'next' : 'prev';
        this.setState({
          origin: {
            x: e.changedTouches[0].pageX,
            y: e.changedTouches[0].pageY
          },
          direction: direction,
          cancelTouch: true
        }); // call correct direction function

        if (direction === 'next') {
          this.handleNextSlide();
        } else {
          this.handlePrevSlide();
        }
      }
    }
  };

  _proto.handleTouchEnd = function handleTouchEnd() {
    this.setState({
      cancelTouch: false
    });
  };

  _proto.getOrder = function getOrder(itemIndex) {
    var _this$state4 = this.state,
        visibleImageIndex = _this$state4.visibleImageIndex,
        carouselImagesLength = _this$state4.carouselImagesLength,
        twoSlidesCarousel = _this$state4.twoSlidesCarousel; // if index is past the end and should wrap around to front of array return desired order

    if (itemIndex - visibleImageIndex < 0) {
      return carouselImagesLength - Math.abs(itemIndex - visibleImageIndex);
    } // if there's just two slides they just go back and forth


    if (carouselImagesLength === twoSlidesCarousel) return itemIndex;
    return itemIndex - visibleImageIndex;
  };

  _proto.preloadImageFirstImage = function preloadImageFirstImage(item) {
    var _this2 = this;

    var firstImageIsLoading = this.state.firstImageIsLoading;
    var firstImageSrc = handleNestedProp(item, 'item.image.image');

    if (firstImageSrc !== ' ') {
      var _img = new Image();

      var imgWidth = 1600;
      _img.src = appendImageTransforms(firstImageSrc, imgWidth);

      if (!_img.complete && _img.naturalHeight === 0 && firstImageIsLoading !== true) {
        this.setState({
          firstImageIsLoading: true
        });

        _img.onload = function () {
          return _this2.setState({
            firstImageIsLoading: false
          });
        };
      }
    }
  };

  _proto.doSliding = function doSliding(direction, visibleImageIndex) {
    var _this3 = this;

    var newState = {
      sliding: true,
      direction: direction,
      visibleImageIndex: visibleImageIndex
    };
    this.setState(newState, function () {
      setTimeout(function () {
        _this3.setState({
          sliding: false
        });
      }, 50);
    });
  };

  _proto.render = function render() {
    var _clsx,
        _this4 = this;

    var _this$state5 = this.state,
        visibleImageIndex = _this$state5.visibleImageIndex,
        carouselImagesLength = _this$state5.carouselImagesLength,
        sliding = _this$state5.sliding,
        direction = _this$state5.direction,
        twoSlidesCarousel = _this$state5.twoSlidesCarousel,
        firstImageIsLoading = _this$state5.firstImageIsLoading,
        handleReloading = _this$state5.handleReloading;
    var _this$props = this.props,
        data = _this$props.data,
        theme = _this$props.theme,
        isLoading = _this$props.isLoading,
        _this$props$isLowCont = _this$props.isLowControls,
        isLowControls = _this$props$isLowCont === void 0 ? false : _this$props$isLowCont;
    var items = isEmptyArray(data.items) ? [] : data.items;

    if (handleReloading && firstImageIsLoading) {
      this.preloadImageFirstImage(items[visibleImageIndex]);
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_configuratorCarousel["default"].loader, (_clsx = {}, _clsx[_configuratorCarousel["default"].isLoading] = isLoading === true || firstImageIsLoading === true, _clsx))
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_configuratorCarousel["default"].carousel, theme['col-xs-12']),
      onTouchStart: function onTouchStart(e) {
        return _this4.handleTouchStart(e);
      },
      onTouchMove: function onTouchMove(e) {
        return _this4.handleTouchMove(e);
      },
      onTouchEnd: function onTouchEnd() {
        return _this4.handleTouchEnd();
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      role: "region",
      "aria-label": "carousel",
      className: _configuratorCarousel["default"].carouselWrapper
    }, /*#__PURE__*/_react["default"].createElement(_configuratorCarouselImages["default"], {
      items: items,
      visibleImageIndex: visibleImageIndex,
      getOrder: this.getOrder,
      sliding: sliding,
      direction: direction,
      carouselImagesLength: carouselImagesLength,
      twoSlidesCarousel: twoSlidesCarousel
    })), items.length > 1 && /*#__PURE__*/_react["default"].createElement(_configuratorCarouselControls["default"], {
      handleNextSlide: this.handleNextSlide,
      handlePrevSlide: this.handlePrevSlide,
      visibleImageIndex: visibleImageIndex,
      carouselImagesLength: carouselImagesLength,
      isLowControls: isLowControls,
      theme: theme
    }), items.length < 2 && /*#__PURE__*/_react["default"].createElement("div", {
      className: _configuratorCarousel["default"].noControls
    })));
  };

  return ConfiguratorCarousel;
}(_react["default"].PureComponent);

exports["default"] = ConfiguratorCarousel;
ConfiguratorCarousel.displayName = 'ConfiguratorCarousel';